import { Box, CircularProgress, Typography } from '@mui/material';
import StarIcon from '../../../assets/images/icons/star_blue.png';
import { useUserStore } from '../../../stores/userStore';
import { addCommaToNumber } from '../../../utils/utils';

const RewardDetailCard = ({ image }) => {
  const companyInfo = useUserStore((state) => state.companyInfo);
  const point = companyInfo ? addCommaToNumber(companyInfo.accumulated_points) : '0';

  return (
    <Box
      sx={{
        width: '100%',
        height: '220px',
        display: 'flex',
        justifyContent: 'space-between',
        position: 'relative',
        padding: '5px 16px',
        marginBottom: '10px',
      }}
    >
      {/* Title */}
      <Typography
        component={'h1'}
        sx={{
          fontSize: '2.2rem',
          lineHeight: '2rem',
          fontWeight: '500',
          color: '#005972',
          marginBottom: '5px',
        }}
      >
        Reward
      </Typography>

      {/* Point */}
      <Box
        sx={{
          position: 'relative',
          zIndex: '10',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end',
        }}
      >
        <Typography
          sx={{
            fontSize: '1.5rem',
            lineHeight: '1.5rem',
            fontWeight: '500',
            color: '#005972',
            textAlign: 'right',
          }}
        >
          คะแนนสะสม
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '3px' }}>
          <Box component={'img'} src={StarIcon} alt="Star Icon" sx={{ width: '25px' }} />
          <Typography
            sx={{ fontSize: '2rem', lineHeight: '2rem', fontWeight: '500', color: '#005972' }}
          >
            {point}
          </Typography>
        </Box>
      </Box>

      {/* Image */}
      {image ? (
        <Box
          component="img"
          src={image}
          alt="Reward"
          sx={{
            width: 'auto',
            height: '170px',
            position: 'absolute',
            top: '60%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        />
      ) : (
        <Box
          sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
        >
          <CircularProgress />
        </Box>
      )}
    </Box>
  );
};

export default RewardDetailCard;
